import React, {useCallback, useMemo} from "react";
import "./index.scss";
import Button from "features/components/button";
import {array, bool, func, number} from "prop-types";
import Text from "features/components/text";
import {__} from "services/i18n";
import Title from "features/components/title";

export const LikeBox = (props) => {
    const {like, total, avatars, onLike} = props;

    const toggleLike = useCallback(() => {
        onLike()
    }, [onLike]);
    const likeMsg = useMemo(() => {
        if(like && total === 1) {
            return "common.like-only-you";
        }
        return total === 0 ? "common.first-to-like" : like ? "common.like-to-you-and-users" : "common.like-to-users";
    }, [like, total]);
    const totalLikes = useMemo(() => {
        if(like) return total - 1;
        return total;
    }, [like, total]);

    return <div className={`like-box ${like ? "like" : "not-like"}`}>
        <Button title={""} onClick={toggleLike} icon={"thumbs-up"} type={"square"} />
        <div className={"likes"}>
            <Text size={14}>{__(likeMsg,[{key: "[count]", value: totalLikes}])}</Text>
            {(!!avatars.length) && <div className={"avatars"}>
                {avatars.map((item, index) => <div key={index}>
                    <img src={item} alt={"like user avatar"} />
                </div>)}
                {total - avatars.length > 0 && <div>
                    <div className="rest">
                        <Title size={10}>+{total - avatars.length}</Title>
                    </div>
                </div>}
            </div>}
        </div>
    </div>
};
LikeBox.propTypes = {
    total: number.isRequired,
    avatars: array,
    like: bool.isRequired,
    onLike: func.isRequired
};